<template>
  <div
    :class="{
      'search-tab-wrap--active': isActive
    }"
    class="search-tab-wrap">
    <div
      :class="{
        'search-tab--active': isActive,
        'search-tab--inactive': isInactive,
      }"
      class="search-tab"
      role="button"
      @click="setActiveTab">
      <span class="search-tab__text">
        <slot></slot>
        <span
          v-if="hasSelectedItems"
          class="search-tab__text-number">{{ numberOfSelectedItems }}</span>
      </span>
      <icon v-if="isActive" link type="angle-up"></icon>
      <icon v-else link type="angle-down"></icon>
    </div>
    <portal-target :name="portalName"></portal-target>
  </div>
</template>

<script>
import Icon from '@/components/Icon'

export default {
  name: 'SearchTab',

  props: {
    activeTab: {
      required: true,
      type: String
    },
    tabName: {
      required: true,
      type: String
    }
  },

  components: {
    Icon
  },

  computed: {
    numberOfSelectedItems() {
      return this.$store.getters.getQueryType(this.tabName)
    },
    hasSelectedItems() {
      return this.numberOfSelectedItems > 0
    },
    isActive() {
      return this.activeTab === this.tabName
    },
    isInactive() {
      return this.activeTab !== '' && this.activeTab !== this.tabName
    },
    portalName() {
      return `mobile-${this.tabName}`
    }
  },

  methods: {
    setActiveTab() {
      this.$emit('activeTab', this.tabName)
      window.eventBus.$emit('close-all-boxes')
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../../variables/custom-media.css';

.search-tab-wrap {
  margin-bottom: 20px;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 10px;
  }

  @media (--bp-desktop) {
    margin-bottom: 0;
    width: auto;

    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
}

.search-tab {
  align-items: center;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: var(--spacing-half) 25px;
  user-select: none;
  width: 100%;

  &:hover {
    background-color: var(--color-white);
  }

  @media (--bp-desktop) {
    justify-content: center;
    min-width: 110px;
    width: auto;

    &:not(:last-child) {
      margin-right: 10px;
    }
  }
}

.search-tab__text {
  font-size: 16px;
  height: 25px;
  margin-right: var(--spacing-half);
  display: flex;
  align-items: center;

  @media (--bp-nis-medium) {
    font-weight: 400;
  }
}

.search-tab__text-number {
  border-radius: 12px;
  width: 25px;
  height: 25px;
  text-align: center;
  background-color: var(--color-geyser);
  color: var(--color-matisse);
  margin-left: var(--spacing-third);
  font-weight: 400;
  line-height: 25px;
}

.search-tab--active {
  background-color: var(--color-white);
  border-radius: 6px 6px 0 0;

  & .search-tab__text {
    font-weight: 700;
  }
}

.search-tab--inactive {
  background-color: var(--color-alabaster);

  @media (--bp-desktop) {
    border-radius: 6px 6px 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchTab.vue